/**
 * Convert a plural English word to singular. Handles common patterns:
 * - "Companies" → "Company" (ies → y)
 * - "Statuses" → "Status" (es after s/x/z/ch/sh → drop es)
 * - "Deals" → "Deal" (s → drop s)
 *
 * Short -ie root words (≤4 chars) like "dies" → "die" are preserved.
 * Longer -ie roots (movies, cookies) are not distinguished from -y roots
 * without a dictionary; CRM entity names reliably follow the ies→y rule.
 */
export function singularize(word: string): string {
  if (/ies$/i.test(word)) {
    // Short -ie roots: dies→die, ties→tie, pies→pie, lies→lie
    if (word.length <= 4) {
      return word.slice(0, -1);
    }
    // Standard consonant+y → ies: companies→company, cities→city
    return word.slice(0, -3) + 'y';
  }
  if (/[sxz]es$/i.test(word) || /(ch|sh)es$/i.test(word)) {
    return word.slice(0, -2);
  }
  if (/s$/i.test(word)) {
    return word.slice(0, -1);
  }
  return word;
}

/** Readable fallback for an unmapped slug: underscores to spaces, first letter capitalized. */
export function humanize(value: string): string {
  const text = value.replace(/_/g, ' ');
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
}
